<template>
  <div>
    <HeaderSteps :title="`Edit ${asset?.name}`" :back-path="-1"> </HeaderSteps>
    <FormCard>
      <h2 class="font-bold mb-3">Assets</h2>
      <ElForm ref="form" @submit.prevent.native label-position="top" label-width="100px">
        <Asset ref="assetForm" v-model="form" />
        <ElButton type="primary" class="w-full" :loading="isSaving" @click="submitForm">Save changes</ElButton>
      </ElForm>
    </FormCard>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import HeaderSteps from '@/components/social-products/social-boost/parts/HeaderSteps.vue'
import CampaignPeriod from '@/components/social-products/social-boost/forms/PeriodBudget.vue'
import Asset from '@/components/social-products/social-boost/forms/Asset.vue'
import FormCard from '@/components/social-products/social-boost/parts/FormCard.vue'

export default {
  name: 'EditAsset',
  components: {
    HeaderSteps,
    CampaignPeriod,
    Asset,
    FormCard,
  },
  data() {
    return {
      isSaving: false,
      form: {},
    }
  },
  created() {
    this.init()
  },
  computed: {
    ...mapGetters('socialBoostCampaign', ['asset', 'campaign']),
    ...mapGetters('app', ['is_loading']),
  },
  watch: {
    asset: {
      handler(value) {
        if (!value) return

        this.form = {
          id: value.id,
          name: value.name || null,
          link: value.post_url || null,
          ctaColor: value.cta_color || null,
          ctaText: value.cta_text || null,
          landingPage: value.landing_page || null,
          mediaType: value.post_url ? 'link' : 'upload',
          files: value?.media_file || [],
          trackingTagsFiles: value?.tracking_tags || [],
        }
      },
      immediate: true,
    },
    campaign: {
      handler(value) {
        if (!value) return
        const getAssetById = this.campaign?.flights
          ?.find((f) => f.id === +this.$route.params.flight_id)
          ?.assets?.find((asset) => asset.id === +this.$route.params.asset_id)
        this.$store.commit('socialBoostCampaign/SET_ASSET', getAssetById)
      },
      immediate: true,
    },
  },
  methods: {
    async init() {
      await this.$store.dispatch('socialBoostCampaign/getCampaign', { id: this.$route.params.id })
    },
    submitForm() {
      this.$refs.assetForm.validate(async (valid) => {
        if (!valid) return

        const data = [{ name: this.form.name, assets: this.form }]
        this.$store.commit('socialBoostCampaign/SET_CAMPAIGN_FORM', { section: 'assets', data })
        this.isSaving = true
        const res = await this.$store.dispatch('socialBoostCampaign/saveAssetsForm', {
          flight_id: this.$route.params.flight_id,
          asset_id: this.$route.params.asset_id,
        })

        this.$router.push({
          name: this.campaign.is_simple ? 'campaign-flight-view' : 'flight-view',
          params: { id: this.$route.params.id, flight_id: this.$route.params.flight_id },
        })

        this.isSaving = false
      })
    },
  },
}
</script>
